import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check, Minus } from "lucide-react"

import { cn } from "lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "tw-group tw-grid tw-place-content-center tw-peer tw-h-4 tw-w-4 tw-shrink-0 tw-rounded-xs tw-border tw-border-input focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-border-primary data-[state=checked]:tw-bg-primary data-[state=checked]:tw-text-primary-foreground data-[state=indeterminate]:tw-border-primary data-[state=indeterminate]:tw-bg-primary data-[state=indeterminate]:tw-text-primary-foreground",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("tw-grid tw-place-content-center tw-text-current")}
    >
      <Minus className="tw-hidden tw-h-4 tw-w-4 group-data-[state=indeterminate]:tw-block" />
      <Check className="tw-h-4 tw-w-4 group-data-[state=indeterminate]:tw-hidden" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
